import "./AsidePane.0.css";
import { startMouseMove } from "../../lib/utils";
import { vueLinkLocalStorage } from "../../lib/utils/vue";
const __script_base__ = {
  name: 'AsidePane',
  props: {
    height: {
      type: String,
      default: ''
    },
    defaultCollapsed: {
      type: Boolean,
      default: false
    },
    disableCollapsing: {
      type: Boolean,
      default: false
    },
    destroyChildrenWhenCollapsed: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      extraHeight: 0,
      collapsed: !!this.defaultCollapsed
    };
  },
  computed: {
    style() {
      const ans = {};
      if (!this.collapsed && this.height) ans.height = `calc(${this.height} + ${this.extraHeight}px)`;
      return ans;
    }
  },
  created() {
    const lcKey = `asidePane:${this.$vnode.key || this.title}`;
    vueLinkLocalStorage(this, lcKey, 'extraHeight');
    vueLinkLocalStorage(this, lcKey, 'collapsed');
  },
  methods: {
    toggle() {
      if (this.disableCollapsing) return;
      this.collapsed = !this.collapsed;
    },
    startResize(event) {
      const o = this.extraHeight;
      startMouseMove({
        initialEvent: event,
        onMove: ({
          deltaY
        }) => {
          // 拖太多会导致domTreeview引起materialBox的问题  -300是实测的阈值
          this.extraHeight = Math.max(-300, o - deltaY);
        }
      });
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-asidePane",
    class: {
      isCollapsed: _vm.collapsed
    },
    style: _vm.style
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.collapsed,
      expression: "!collapsed"
    }],
    staticClass: "ucd-asidePane-resizer",
    on: {
      mousedown: _vm.startResize,
      touchstart: _vm.startResize
    }
  }), _vm._v(" "), _vm.title ? _c("div", {
    staticClass: "ucd-asidePane-title",
    on: {
      click: _vm.toggle
    }
  }, [_c("i", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.disableCollapsing,
      expression: "!disableCollapsing"
    }],
    staticClass: "fa ucd-asidePane-title-expandIcon",
    class: _vm.collapsed ? "fa-plus-square-o" : "fa-minus-square-o"
  }), _vm._v("\n\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "ucd-asidePane-content"
  }, [!(_vm.collapsed && _vm.destroyChildrenWhenCollapsed) ? _vm._t("default") : _vm._e()], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/AsidePane.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);